import {
    changeFieldDisabled,
    changeFieldProperty,
    setFieldListOptions, setFormButtons
} from "../../../apps/KpModule/actions"
import Errors from '../../utils/Errors'
import {getDataListList} from "../../../apps/KpModule/selectors"
import {getFieldModuleForm} from "./themeConfig";
import {generateFetchFieldListAction} from "../../../apps/KpModule/actions/api"
import {groupIdForMongoQuery} from "./engines/alert/mongoPipeline"
import {basicContext} from "../../utils/contextUtils";
import {buildAlertPeriodQuery} from "./utils/alertPeriodQuery";

const async = require("async");
const moment = require("moment");
const _ = require("lodash");
const { setFieldVisibility } = require("../../../apps/KpModule/actions")

const todayISO = moment().format("YYYY-MM-DD");
const lastWeekISO = moment().subtract(7, "days").format("YYYY-MM-DD");

const cacheOnContext = async function(context) {
    if (!context.data || !context.data.alertsByConfigs) {
        const alertsByConfigs = await userAlertsByAlertConfig(context);
        context.data = context.data ? context.data : {};
        _.assign(context.data, {alertsByConfigs});
    }
    return context;
};

const userAlertsByAlertConfig = async function(context) {
    const wfContext = _.defaults({}, context);

    wfContext.userHabFunctions = await global.app.S.User.getUserHabFunctions(wfContext.user, context);
    wfContext.groupAxes = await global.app.S.GroupAxis.find({ ...basicContext(context), query: {} });

    if (context.id && (_.get(context, "access.entity.name") === "AlertConfiguration")) {
        const alertConfiguration = await global.app.S.AlertConfiguration.collection.findOne({ _id: new global.ObjectID(context.id) });
        wfContext.userAlertConfigurations = [alertConfiguration];
    } else {
        wfContext.userAlertConfigurations = await global.app.S.AlertConfiguration.getAlertConfigurationsForHabFunctions(wfContext.userHabFunctions);
    }

    return Promise.all(wfContext.userAlertConfigurations
        .filter(alertConfiguration => {
            if(!wfContext.data?.alertConfigurations?.length) return true
            return wfContext.data.alertConfigurations.map(alertConf => alertConf.id).includes(alertConfiguration._id.toString())
        })
        .map(async function(alertConfiguration) {
            if (['00000000000000000000000d', '000000000000000000000002'].includes(alertConfiguration.timeWindow.toString())) {
                const pipeline = global.app.S.AlertConfiguration.getYearAlertAggregationPipeline(alertConfiguration, wfContext);
                const alerts = await global.app.S.Alert.collection.aggregate(pipeline, { allowDiskUse: true }).toArray();
                return { alertConfiguration, alerts, consultedAlertsNb: alerts.filter(alert => !!alert.consulted).length };
            } else {
                const query = global.app.S.AlertConfiguration.getAlertQueryFilter(alertConfiguration, wfContext);
                const alerts = await global.app.S.Alert.collection.find(query).toArray();
                return { alertConfiguration, alerts, consultedAlertsNb: alerts.filter(alert => !!alert.consulted).length };
            }
        })
    );
};

// add StoreAxis if groupAxes contain any SubStoreAxis
const groupAxesWithStore = alertConfiguration => {
    /*
    const groupAxisOfType = type => alertConfiguration.groupAxes.some(
        groupAxis => groupAxis.joinedEntity === type
    );

    const isSubStore = groupAxisOfType("SubStoreAxis");
    const isStore = groupAxisOfType("StoreAxis");
     */

    return _.compact([
        ...alertConfiguration.groupAxes
    ]);
};

function fetchDataLists(store, flow, conditionType) {
    store.dispatch(
        generateFetchFieldListAction(
            "m-S-alertConfiguration.AlertConfCondition_source",
            store.getState,
            {data: {flow: flow, dataTypes: conditionType?.dataTypes} }
        )
    )
    store.dispatch(
        generateFetchFieldListAction(
            "m-S-alertConfiguration.AlertConfCondition_source2",
            store.getState,
            {data: {flow: flow, dataTypes: conditionType?.dataTypes} }
        )
    )
    store.dispatch(
        generateFetchFieldListAction(
            "m-S-alertConfiguration.AlertConfCondition_source3",
            store.getState,
            {data: {flow: flow, dataTypes: conditionType?.dataTypes} }
        )
    )
}

export const dependencies = [
    {
      name: "AlertDescription",
      fields: [
          "Language",
          "description"
      ]
    },
    {
        name: "AggOperator",
        type: "static",
        fields: [
            {path: "id", type: "id"},
            "mongoOperator",
            "tKey"
        ],
        objects: [
            {id: "000000000000000000000001", tKey: "sum", mongoOperator: "$sum"},
            {id: "000000000000000000000002", tKey: "average", mongoOperator: "$avg"},
            {id: "000000000000000000000003", tKey: "maximum", mongoOperator: "$max"},
            {id: "000000000000000000000004", tKey: "minimum", mongoOperator: "$min"},
            {id: "000000000000000000000005", tKey: "existence"}
        ]
    },
    {
        name: "AlertConfConditionGroup",
        type: "mongoInternal",
        fields: [
            "name",
            {path: "conditions", type: "AlertConfCondition", link: "OTM"}
        ]
    },
    {
        name: "AlertConfCondition",
        type: "mongoInternal",
        fields: [
            {type: "ConditionType", nullable: true},
            {path: "stream", type: "InputCorrespondenceByImportType"},
            {path: "source", type: "InputCorrespondence", uniqueWith: ["operator", "condValue", "source2", "source3"]},
            {path: "source2", type: "InputCorrespondence", nullable: true},
            {path: "source3", type: "InputCorrespondence", nullable: true},
            {
                path: "source2OrSource3",
                fieldPath: ["source2.name", "source3.name"],
                f: function() {
                    return this.source2?.name || this.source3?.name
                }
            },
            {path: "operator", type: "CondOperator"},
            {path: "aggOperator", type: "CondAggOperator", nullable: true},
            "condValue",
            "condValues"
        ]
    },
    {
        name: "AlertEngineOrder",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "tKey", "tKey2"
        ],
        objects: [
            {
                id: "aggregationRatioCondition",
                tKey: "analysisMesh",
                tKey2: "analysisMesh",
            },
            {
                id: "ratioConditionAggregation",
                tKey: "elementaryMesh",
                tKey2: "intermediateMesh",
            }
        ]
    },
    {
        name: "DisplayedResult",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "name"
        ],
        objects: [
            {id: "indicators", name: "indicatorsSumAtAnalysisMesh"},
            {id: "occurrencesNumber", name: "occurrencesNumberAtAnalysisMesh"}
        ]
    },
    {
        name: "ManualAlertsInDatesForUser",
        type: "mongoInternal",
        fields: [
            {path: "consulted", type: "boolean"},
            {path: "dataPeriod"},
            {path: "meshWithoutGroupAxisLinks", type: "object"},
            {path: "uniqValuesByDelay", type: "object"}
        ]
    },
    {
        name: "AlertField",
        type: "mongoInternal",
        fields: [
            {path: "type", type: "RuleType"},
            "ThemeJoin",
            "ThemeFieldType",
            {
                path: "numeratorDelay",
                type: "integer"
            },
            {path: "denominatorTheme", type: "ThemeJoin", nullable: true},
            {path: "denominatorThemeFieldType", type: "ThemeFieldType", nullable: true},
            {
                path: "denominatorDelay",
                type: "integer"
            },
            {path: "aggOperator", type: "AggOperator", nullable: true},
            {path: "preAggOperator", type: "AggOperator", nullable: true},
            {path: "condOperator", type: "CondOperator", nullable: true},
            {path: "value", nullable: true, type: "decimal"},
            "AlertEngineOrder",
            {type: "DisplayedResult"},
            {
                path: "themeFieldPath",
                fieldPath: ["themeJoin.completeCode", "themeFieldType.code"],
                f: function() {
                    return this.themeJoin
                        ? this.themeJoin.completeCode + "." + this.themeFieldType.code
                        : undefined;

                }
            },
            {
                path: "themeStreamId",
                fieldPath: ["themeJoin.streamId"],
                f: function() {
                    return this.themeJoin?.streamId
                }
            },
            {
                path: "denominatorThemeFieldPath",
                fieldPath: ["denominatorTheme.completeCode", "denominatorThemeFieldType.code"],
                f: function() {
                    return this.denominatorTheme
                        ? this.denominatorTheme.completeCode + "." + this.denominatorThemeFieldType.code
                        : undefined;
                }
            },
            {
                path: "denominatorThemeStreamId",
                fieldPath: ["denominatorTheme.streamId"],
                f: function() {
                    return this.denominatorTheme?.streamId
                }
            },
            {
                path: "themeFieldPaths",
                lazy: true,
                fieldPath: ["themeFieldPath", "denominatorThemeFieldPath"],
                f: function() {
                    return _.compact([this.themeFieldPath, this.denominatorThemeFieldPath]);
                }
            },
            {
                path: "preGroupObjectForMongo",
                lazy: true,
                fieldPath: ["themeFieldPath", "themeFieldType.code", 'denominatorThemeFieldPath', "denominatorThemeFieldPath", "denominatorThemeFieldType.code", "denominatorThemeLineCount", "preAggOperator.id", "preAggOperator.mongoOperator"],
                f: function() {

                    return ["theme", "denominatorTheme"].reduce((acc, fieldPath) => {
                        return Object.assign(
                            acc,
                            this[`${fieldPath}FieldPath`]
                                ? {
                                    [this[`${fieldPath}FieldPath`].replace(/\./g,' ')]: this.preAggOperator?.id === "000000000000000000000005"
                                        ? {
                                        "$max": {
                                                "$cond": [{ "$ifNull": [`$${this[`${fieldPath}FieldPath`]}`, false] }, 1, 0]
                                            }
                                        }
                                        : {
                                            [this.preAggOperator?.mongoOperator]: `$${this[`${fieldPath}FieldPath`]}`
                                        }
                                }
                                : {}
                        )
                    }, {})

                }
            },
            {
                path: "themeFieldPathsWithNumeratorOrDenominator",
                lazy: true,
                fieldPath: ["themeFieldPath", "denominatorThemeFieldPath"],
                f: function() {
                    return _.compact([
                        this.themeFieldPath && `numerator-${this.themeFieldPath}`,
                        this.denominatorThemeFieldPath && `denominator-${this.denominatorThemeFieldPath}`
                    ]);
                }
            }
        ]
    }
]

export const entity = {
    name: "AlertConfiguration",
    facets: ["codeName", "description", "translatedField"],
    fields: [
        "TimeWindow",
        {path: "hasTimeInterval", type: "boolean"},
        {type: "AlertDescription", link: "OTM"},
        "startTime",
        "endTime",
        {path: "fromFiscalYearStart", type: "boolean"},
        {path: "filterFields", type: "Scope", link: "MTM"},
        {
            path: "preGroupAxes",
            type: "GroupAxis",
            link: "MTM",
            nullable: true
        },
        {
            path: "groupAxes",
            type: "GroupAxis",
            link: "MTM",
            nullable: true
        },
        {
            path: "habFunctionHabilitation",
            type: "HabFunction",
            link: {type: "MTM", oppositeField: {link: {deleteType: "block"}}}
        },
        {path: "conditionGroups", type: "AlertConfConditionGroup", link: "OTM"},
        {type: "AlertField", link: "OTM", notEmpty: true},
        {type: "Alert", link: {type: "OTM", deleteType: "cascade", oppositeField: {index: true}}},
        {type: "WeekDay", link: "MTO", nullable: true},
        {type: "MonthDay", link: "MTO", nullable: true},
        {path: "sendJournal", type: "boolean", nullable: true},
        {path: "dormant", type: "boolean", default: false},
        {
            path: "reason",
            type: "Reason",
            link: {type: "MTM", oppositeField: {link: {deleteType: "block"}}}
        },
        {
            type: "integer",
            path: "delay",
            notEmpty: true
        },
        {
            path: "filterFieldsRefs",
            lazy: true,
            fieldPath: ["filterFields.name"],
            $f: function(alertConfiguration, context, callback) {
                callback(null, alertConfiguration.filterFields.length ? alertConfiguration.filterFields.map(filterField => filterField.name).join(", ") : "All");
            }
        },
        {
            path: "groupAxesRefs",
            lazy: true,
            fieldPath: ["groupAxes.name"],
            $f: function(alertConfiguration, context, callback) {
                callback(null, alertConfiguration.groupAxes.map(groupeAxes => groupeAxes.name).join(", "));
            }
        },
        {
            path: "alertsInDatesForUser",
            type: "ManualAlertsInDatesForUser",
            lazy: true,
            $f: async function (alertConfiguration, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);
                    const alertsByConfig = _.find(
                        newContext?.data.alertsByConfigs,
                        alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === alertConfiguration.id
                    );

                    if(!alertsByConfig || !alertsByConfig.alerts) {
                        return [];
                    }

                    const alerts = await global.app.S.Alert.find({
                        group: newContext.group,
                        fieldPath: ["id", "code", "dataPeriod", "lineCount", "uniqValuesByDelay", "meshWithoutGroupAxis", "meshWithoutGroupAxisLinks", "consulted", "lastUpdate", "lastUpdateBy.name"],
                        query: {
                            _id: {$in: _.map(alertsByConfig.alerts, "_id")}
                        }
                    })

                    return callback(null, alerts)
                } catch (e) {
                    return callback(e)
                }
            },
            $s: (alerts, alertConfiguration, context, callback) => {
                alertConfiguration.updatedAlerts = alerts

                callback();
            }
        },
        //{ path: "updatedAlerts"},
        {
            path: "alertsNbByDate",
            lazy: true,
            $f: async function (alertConfiguration, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);

                    const alertsByConfig = _.find(
                        newContext?.data.alertsByConfigs,
                        (alertsByConfig) =>
                            alertsByConfig.alertConfiguration._id.toString() === alertConfiguration.id
                    );

                    if (!alertsByConfig || !alertsByConfig.alerts) {
                        return callback(null, []);
                    }

                    const countsByDate = Object.values(
                        alertsByConfig.alerts.reduce((acc, alert) => {
                            // original datetime from alert
                            const d = new Date(alert.date.lt);

                            // normalize to local day (midnight), then subtract 1 day
                            const dMinus1 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
                            dMinus1.setDate(dMinus1.getDate() - 1);

                            // group key: YYYY-MM-DD based on the shifted day
                            const yyyy = dMinus1.getFullYear();
                            const mm = String(dMinus1.getMonth() + 1).padStart(2, "0");
                            const dd = String(dMinus1.getDate()).padStart(2, "0");
                            const dateKey = `${yyyy}-${mm}-${dd}`;

                            // display: DD/MM/YYYY (shifted)
                            const formattedDate = dMinus1.toLocaleDateString("fr-FR");

                            if (!acc[dateKey]) {
                                acc[dateKey] = {
                                    dataPeriod: formattedDate,
                                    alertsNb: 0,
                                };
                            }

                            acc[dateKey].alertsNb += 1;
                            return acc;
                        }, {})
                    );

                    return callback(null, countsByDate);
                } catch (e) {
                    return callback(e);
                }
            },
        },
        {
            path: "alertNb",
            lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);
                    const alertsByConfig = _.find(
                        newContext.data.alertsByConfigs,
                        alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === object.id
                    );
                    const alerts = _.get(alertsByConfig, "alerts", []);
                    return callback(null, alerts.length)
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "consultedAlertsNb",
            //lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);
                    const alertsByConfig = _.find(
                        newContext.data.alertsByConfigs,
                        alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === object.id
                    );
                    return callback(null, _.get(alertsByConfig, "consultedAlertsNb", 0))
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "activationDay",
            fieldPath: ["weekDay", "monthDay"],
            f: function() {
                return this.weekDay
                    ? (this.monthDay ? this.weekDay.name + ", " + this.monthDay.name : this.weekDay.name)
                    : (this.monthDay ? this.monthDay.name : "Every Day");
            }
        },
        {
            path: "groupAxisName",
            lazy: true,
            fieldPath: ["groupAxes.id"],
            $f: (alertConfiguration, context, callback) => callback(
                null,
                groupAxesWithStore(alertConfiguration).map(
                    groupAxis => global.app.S.GroupAxis.translateName(groupAxis, context)
                ).join(" | ")
            )
        },
        {
            path: "themesKeysUniqByDelay",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeCode",
                "alertFields.themeJoin.completeCodeWithoutPrefix",
                "alertFields.themeFieldType.code",
                "alertFields.denominatorTheme.completeCode",
                "alertFields.denominatorTheme.completeCodeWithoutPrefix",
                "alertFields.denominatorThemeFieldType.code",
                "alertFields.displayedResult.id"
            ],
            f: function(){
                return _(this.alertFields)
                    .flatMap((alertField, index) => {
                        if(alertField.displayedResult?.id === 'occurrencesNumber') {
                            return [{displayLineCount: true}]
                        }
                        return [
                            {themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType, prefix: `${index}-numerator-theme`,  delay: alertField.numeratorDelay},
                            {themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType, prefix: `${index}-denominator-theme`, delay: alertField.denominatorDelay}
                        ]
                    })
                    .filter(element => element.displayLineCount || !!element.themeJoin)
                    .uniqBy(o => {
                        return o.displayLineCount || o.themeJoin.completeCode + o.fieldType.code + o.delay
                    })
                    .map(
                        o => {
                            return o.displayLineCount
                                ? `lineCount`
                                : `${o.prefix}-${o.themeJoin.completeCodeWithoutPrefix}.${o.fieldType.code}`
                        }
                    )
                    .value();
            }
        },
        {
            path: "themeNames",
            lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const alertConf = await global.app.S.AlertConfiguration.get(
                        object.id,
                        {
                            group: context.group,
                            fieldPath: ["themesNamesWithDelay"],
                        },
                    );
                    return callback(null, alertConf.themesNamesWithDelay.join(";"))
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "brutSummedAlertsValues",
            lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);
                    const alertsByConfig = _.find(
                        newContext.data.alertsByConfigs,
                        alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === object.id
                    );
                    const alerts = _.get(alertsByConfig, "alerts", []);


                    const alertConf = await global.app.S.AlertConfiguration.get(
                        object.id,
                        {
                            group: context.group,
                            fieldPath: ["themesKeysUniqByDelay"],
                        }
                    );

                    const result = alerts.reduce((acc, alert) => {
                        return alertConf.themesKeysUniqByDelay.map((key, index) => acc[index] + _.get(alert, key, 0))

                    }, Array(alertConf.themesKeysUniqByDelay.length).fill(0));

                    return callback(null, result
                        .map(value => _.round(value))
                        .join(' | ')
                    )
                } catch (e) {
                    callback(e)
                }
            }
        },
        {
            path: "summedAlertsValues",
            lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const newContext = await cacheOnContext(context);
                    const alertsByConfig = _.find(
                        newContext.data.alertsByConfigs,
                        alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === object.id
                    );
                    const alerts = _.get(alertsByConfig, "alerts", []);
                    const alertConfId = _.get(alertsByConfig, "alertConfiguration._id");


                    const alertConf = await global.app.S.AlertConfiguration.get(
                        alertConfId.toString(),
                        {
                            group: context.group,
                            fieldPath: ["themesKeysUniqByDelay"],
                        }
                    );
                    const result = alerts.reduce((acc, alert) => {
                        return alertConf.themesKeysUniqByDelay.map((key, index) => acc[index] + _.get(alert, key, 0))

                    }, Array(alertConf.themesKeysUniqByDelay.length).fill(0))

                    return callback(null, result
                        .map(value => _.round(value))
                        .reduce((acc, value, index) => ({...acc, [`indicator${index + 1}`]: value}), {})
                    )
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "themesNamesWithDelay",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeCode",
                "alertFields.themeJoin.completeName",
                "alertFields.themeFieldType.code",
                "alertFields.denominatorTheme.completeCode",
                "alertFields.denominatorTheme.completeName",
                "alertFields.denominatorThemeFieldType.code",
                "alertFields.displayedResult.id"
            ],
            f: function() {
                return _(this.alertFields)
                    .flatMap(alertField => {
                        if(alertField.displayedResult?.id === 'occurrencesNumber') {
                            return [{displayLineCount: true}]
                        }
                        return [
                            {themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType, delay: alertField.numeratorDelay},
                            {themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType, delay: alertField.denominatorDelay}
                        ]
                    })
                    .filter(element => element.displayLineCount || !!element.themeJoin)
                    .uniqBy(o => {
                        return o.displayLineCount || o.themeJoin.completeCode + o.fieldType.code + o.delay
                    })
                    .map(
                        o => {
                            return o.displayLineCount
                                ? `Nombre d'occurrences`
                                : o.delay
                                    ? `${o.themeJoin.completeName} > ${o.fieldType.code} avec un décalage de ${o.delay}`
                                    : `${o.themeJoin.completeName} > ${o.fieldType.code}`
                        }
                    )
                    .value();
            }
        },
        {
            path: "themesNameWithDelay",
            lazy: true,
            fieldPath: ["themesNamesWithDelay"],
            f: function(){
                return this.themesNamesWithDelay.join(";");
            }
        },
        {
            path: "themesKeys",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeCodeWithoutPrefix",
                "alertFields.themeFieldType.code",
                "alertFields.denominatorTheme.completeCodeWithoutPrefix",
                "alertFields.denominatorThemeFieldType.code"
            ],
            f: function(){
                return _(this.alertFields)
                    .flatMap((alertField, index) => [
                        {themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType, prefix: `${index}-numerator-theme`},
                        {themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType, prefix: `${index}-denominator-theme`}
                    ])
                    .filter("themeJoin")
                    .map(
                        o => `${o.prefix}-${o.themeJoin.completeCodeWithoutPrefix}.${o.fieldType.code}`
                    )
                    .uniq()
                    .value();
            }
        },
        {
            path: "dashboardThemeKeysObjects",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeName",
                "alertFields.themeFieldType.code",
                "alertFields.themeJoin.completeCodeWithoutPrefix",
                "alertFields.denominatorTheme.completeName",
                "alertFields.denominatorTheme.completeCodeWithoutPrefix",
                "alertFields.denominatorThemeFieldType.code"
            ],
            $f: function(alertConfiguration, context, callback){
                const translate = name => context.tc
                    ? context.tc(name, _.get(context, 'language.id'))
                    : t => t
                return callback(null,
                    _(alertConfiguration.alertFields)
                        .flatMap((alertField, index) => [
                            {index, themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType, prefix: `${index}-numerator-theme`, name: alertField.themeJoin?.completeName},
                            {index, themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType, prefix: `${index}-denominator-theme`, name: alertField.denominatorTheme?.completeName}
                        ])
                        .filter("themeJoin")
                        .map(
                            o => ({
                                id: `${o.prefix}-${o.themeJoin.completeCodeWithoutPrefix}`,
                                prefix: o.prefix,
                                path: `${o.prefix}-${o.themeJoin.completeCodeWithoutPrefix}.${o.fieldType.code}`,
                                name: `${translate('rule')} ${o.index + 1} : ${o.name} ${o.fieldType.code}`,
                            })
                        )
                        .value()
                )
            }
        },
        {
            path: "completeThemesNames",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeName",
                "alertFields.themeFieldType.code",
                "alertFields.denominatorTheme.completeName",
                "alertFields.denominatorThemeFieldType.code"
            ],
            f: function(){
                return _(this.alertFields)
                    .flatMap(alertField => [
                        {themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType},
                        {themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType}
                    ])
                    .filter("themeJoin")
                    .map(
                        o => `${o.themeJoin.completeName} > ${o.fieldType.code}`
                    )
                    .value()
            }
        },
        {
            path: "themesNames",
            lazy: true,
            fieldPath: [
                "alertFields.themeJoin.completeName",
                "alertFields.themeFieldType.code",
                "alertFields.denominatorTheme.completeName",
                "alertFields.denominatorThemeFieldType.code"
            ],
            f: function(){
                return _(this.alertFields)
                    .flatMap(alertField => [
                        {themeJoin: alertField.themeJoin, fieldType: alertField.themeFieldType},
                        {themeJoin: alertField.denominatorTheme, fieldType: alertField.denominatorThemeFieldType}
                    ])
                    .filter("themeJoin")
                    .map(
                        o => `${o.themeJoin.completeName} > ${o.fieldType.code}`
                    )
                    .uniq()
                    .value();
            }
        },
        {
            path: "themesName",
            lazy: true,
            fieldPath: ["themesNames"],
            f: function(){
                return this.themesNames.join(" | ");
            }
        },
        {
            path: "filterFieldsName",
            fieldPath: ["filterFields.name"],
            f: function(){
                return this.filterFields.length ? this.filterFields.map(filterField => filterField.name).join(", ") : "All";
            }
        },
        {
            path: "baseDay",
            fieldPath: ["delay"],
            lazy: true,
            $f: function (object, context, callback) {
                const baseDay = moment.utc(context.referenceDate).subtract(object.delay, "days").toDate();
                callback(null, baseDay);
            }
        },
        {
            path: "queryDates",
            fieldPath: ["timeWindow.quantity", "timeWindow.period"],
            lazy: true,
            $f: async function (object, context, callback) {
                try {
                    const generalSettings = await global.app.S.GeneralSettings.collection.findOne(
                        {group: new global.ObjectID(context.group.id)}
                    );
                    const periodEnd = moment.utc(context.referenceDate)
                        .add(1, "days")
                        .subtract(generalSettings.delay, "days")

                    if(generalSettings && object.timeWindow.id === '00000000000000000000000d'){
                        const fiscalYearStartDate = `${generalSettings.month}-${generalSettings.monthNumber}`

                        const fiscalYearStart = moment.utc(fiscalYearStartDate, 'MM-DD')

                        const periodStart = periodEnd.isSameOrAfter(fiscalYearStart)
                            ? fiscalYearStart
                            : fiscalYearStart.subtract(1, 'years')

                        return callback(null, {
                            $gte: periodStart,
                            $lt: periodEnd
                        })
                    }

                    if(object.timeWindow.id === '000000000000000000000002'){
                        const yearStart = moment.utc().startOf('year')

                        const periodStart = periodEnd.isSameOrAfter(yearStart)
                            ? yearStart
                            : yearStart.subtract(1, 'years')
                        return callback(null, {
                            $gte: periodStart,
                            $lt: periodEnd
                        })
                    }

                    return callback(null, {
                        $gte: moment.utc(context.referenceDate)
                            .add(1, "days")
                            .subtract(generalSettings.delay, "days")
                            .subtract(object.timeWindow.quantity, object.timeWindow.period),
                        $lt: periodEnd
                    })
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: 'hasCalculatedData',
            $f: (alertConfiguration, context, callback) => {
                global.app.S.Alert.collection
                    .findOne({alertConfiguration: new global.ObjectID(alertConfiguration.id)})
                    .then(alert => callback(null, !!alert))
                    .catch(e => callback(e))
            }
        }
    ],
    filters: [
        {
            path: 'cotisation',
            tKey: 'Statut',
            object: 'CotisationStatus',
            display: "name",
            type: 'tags',
            client: true,
            default: [{id: 'settled', name: 'Réglé'}, {id: 'unsettled', name: 'Non réglé'}, {id: 'pending', name: 'En attente'}]
        },
        {
            name: "isDormant",
            path: "statuses",
            object: "ObjectStatus",
            display: "name",
            isDefault: false,
            type: "tags",
            client: true,
            default: [{id: "active"}],
            query: function(context) {
                const statuses = _.get(context, "data.statuses", [])

                if(!statuses.length) return {_id: null}
                if(statuses.length === 2) return {}

                const status = statuses[0]
                return {dormant: status.id === "suspended"}
            }
        },
        {
            name: "sendJournal",
            query: function(context) {
                if(context.sendJournal) return {sendJournal: context.sendJournal};
            }
        },
        {
            name: "alertConfigurationsByHabFunctions",
            isDefault: false,
            async: true,
            query: async function (context, callback) {
                try {
                    const  userHabFunctions = await global.app.S.User.getUserHabFunctions(context.user, context)
                    return callback(
                        null,
                        {$or: [
                                {habFunctionHabilitation: {$size: 0}},
                                {habFunctionHabilitation: {$in: userHabFunctions.map(hf => new global.ObjectID(hf.id))}}
                            ]}
                    )
                } catch (e) {
                    callback(e)
                }
            }
        },
        {
            name: "hasStoreAxis",
            isDefault: false,
            client: false,
            match: function (object) {
                return object.groupAxes.some(o => o.joinedEntity === "StoreAxis")
            }
        },
        {
            name: "analysisMeshIncludesScoringObject",
            isDefault: false,
            query: function(context) {
                const scoredObject = _.get(context, 'data.scoredObject')
                if(!scoredObject || !scoredObject.length) return {}
                return {groupAxes: {$all: scoredObject.map(scoredObject => new global.ObjectID(scoredObject.id))}}
            },
        }
    ],
    ps: {
        context: [{
            $$u: function (context, callback) {
                if (this.options.accessType === "S" && context.restAction && context.restAction.crudType === "U") {
                    const fieldPathAlertConf = ["habFunctionHabilitation.organizationAxisJoin.joinedEntity"]
                    context.internalFieldPath.push(...fieldPathAlertConf);
                }
                callback(null, context);
            }
        }]
    },
    validateDelete: async function (object, context, callback) {
        try {
            await Promise.all([
                global.app.S.Alert.collection.deleteMany({alertConfiguration: new global.ObjectID(object.id), group: new global.ObjectID(context.group.id)}),
                global.app.S.WorkflowConfigsByAlert.collection.deleteMany({alertConfiguration: new global.ObjectID(object.id), group: new global.ObjectID(context.group.id)}),
                global.app.S.WorkflowConfig.collection.deleteMany({ alertConfiguration: new global.ObjectID(object.id), group: new global.ObjectID(context.group.id) }),
                global.app.S.StaticWorkflow.collection.deleteMany({alertConfiguration: new global.ObjectID(object.id), group: new global.ObjectID(context.group.id)}),
            ]);
            callback();
        } catch (e) {
            callback(e);
        }
    },
    groupAxesValidations: (alertConf, context, callback) => {
        const groupAxes = alertConf.groupAxes;
        const habFunctionHabilitations = alertConf.habFunctionHabilitation;

        /*
        if(groupAxes.length > 2) {
            return callback(new Errors.ValidationError(context.tc("theyCantBeMoreThanTwoElements")));
        }
         */

        const orgAxisOccurences = _.filter(groupAxes, {joinedEntity: "OrganizationAxis"}).length;
        if( orgAxisOccurences > 1){
            return callback(new Errors.ValidationError(context.tc("theOrganizationalAxisMustBeSelectedOnce")));
        }

        if( _.filter(groupAxes, {joinedEntity: "FamilyAxis"}).length > 1){
            return callback(new Errors.ValidationError(context.tc("theFamilyAxisMustBeSelectedOnce")));
        }

        if(orgAxisOccurences === 1 && groupAxes.some(ga => _.includes(["SubStoreAxis", "StoreAxis"], ga.joinedEntity))){
            return callback(new Errors.ValidationError(context.tc("theOrganizationalAxisCantbeSelectedWhithStoreAxisOrSubStoreAxis")));
        }


        if( groupAxes.length > 1 &&
            groupAxes.every(ga => _.includes(["FamilyAxis", "ProductAxis"], ga.joinedEntity)) ){

            return callback(new Errors.ValidationError(context.tc("theFamilyAxisCantBeSelectedWithProduct")));
        }

        if( groupAxes.length === 1 &&
            _.includes(["ProductAxis", "FamilyAxis"], groupAxes[0].joinedEntity) &&
            habFunctionHabilitations.some(hFH => hFH.organizationAxisJoin.joinedEntity !== "CentralAxis") ) {

            return callback(new Errors.ValidationError(context.tc("youCanUseOnlyCentralHabilitation")));
        }

        if( groupAxes.some(ga => _.includes(["OrganizationAxis"], ga.joinedEntity)) &&
            habFunctionHabilitations.some(hFH => _.includes(["StoreAxis"], hFH.organizationAxisJoin.joinedEntity)) ) {

            return callback(new Errors.ValidationError(context.tc("youCantUseStoreAxisHabilitation")));
        }

        const alertFields = alertConf.alertFields
        if(alertFields.some(af => af.denominatorTheme && !af.denominatorThemeFieldType)){
            return callback(new Errors.ValidationError(context.tc("theDenominatorFieldIsRequiredWhenDenominatorIsSelected")));
        }

        return callback()
    },
    filterFieldsValidation: (alertConf, context, callback) => {

        const seenCodes = new Set()

        for (const field of alertConf.filterFields) {
            const code = field.scopeAxe?.code
            if (code) {
                if (seenCodes.has(code)) {
                    return callback(new Errors.ValidationError(context.tc("duplicateAxes")))
                }
                seenCodes.add(code);
            }
        }

        return callback()
    },
    validateSave: function(alertConf, oldAlertConf, context, callback) {
        const moduleId = _.get(context, "module.id")
        if(context.action === 'updateAlertStatus' && moduleId === "m-S-alerts") return callback()
        async.series(
            [
                callback => this.groupAxesValidations(alertConf, context, callback),
                callback => this.filterFieldsValidation(alertConf, context, callback)
            ],
            callback
        )
    },
    beforeSave: async function(alertConf, oldAlertConf, context, callback) {
        const crudType = context.restAction && context.restAction.crudType
        const moduleId = _.get(context, "module.id")

        if (crudType === 'C') {
            const automaticReason = await global.app.S.Reason.collection.findOne({automatic: true})
            if(automaticReason) {
                alertConf.reason = [{id: automaticReason._id.toString()}]
            }
            return callback(null, alertConf, oldAlertConf)
        }

        if(context.action === 'updateAlertStatus' && moduleId === "m-S-alerts") {
            const alertsByConfig = _.find(
                context.data.alertsByConfigs,
                alertsByConfig => alertsByConfig.alertConfiguration._id.toString() === alertConf.id
            );
            const previousAlertsMap = new Map(alertConf.alertsInDatesForUser.map(alert => [alert.id, alert]));

            const changedAlerts = alertConf.updatedAlerts.filter(alert =>
                previousAlertsMap.has(alert.id) && previousAlertsMap.get(alert.id).consulted !== alert.consulted
            )

            delete alertConf.updatedAlerts

            if(!!changedAlerts.length) {
                const alertsChangingToTrue = changedAlerts.filter(alert => alert.consulted === true)
                const alertsChangingToFalse = changedAlerts.filter(alert => alert.consulted === false)

                const previousConsultedAlertsNb = _.get(alertsByConfig, "consultedAlertsNb", 0)

                alertsByConfig.consultedAlertsNb = previousConsultedAlertsNb + alertsChangingToTrue.length - alertsChangingToFalse.length

                if(!!alertsChangingToTrue.length) {
                    await global.app.S.Alert.collection.updateMany(
                        {_id: {$in: alertsChangingToTrue.map(alert => new global.ObjectID(alert.id))}},
                        {
                            $set: {
                                consulted: true,
                                lastUpdate: new Date(),
                                lastUpdateBy: new global.ObjectID(context.user.id)
                            }
                        }
                    )
                }

                if(!!alertsChangingToFalse.length) {
                    await global.app.S.Alert.collection.updateMany(
                        {_id: {$in: alertsChangingToFalse.map(alert => new global.ObjectID(alert.id))}},
                        {
                            $set: {
                                consulted: false,
                                lastUpdate: new Date(),
                                lastUpdateBy: new global.ObjectID(context.user.id)
                            }
                        }
                    )
                }
            }
        }
        callback(null, alertConf, oldAlertConf)
    },
    getAlertConfigurationsForHabFunctions: function(uHabFuncs, callback) {
        const promise = this.collection
            .find({
                $or: [
                    //{habFunctionHabilitation: {$size: 0}},
                    {habFunctionHabilitation: {$in: uHabFuncs.map(hf => new global.ObjectID(hf.id))}}
                ]
            })
            .toArray();
        if (callback) {
            promise
                .then(results => callback(null, results))
                .catch(err => callback(err));
        } else {
            return promise;
        }
    },
    getYearAlertAggregationPipeline: function(alertConfiguration, context) {
        const query = this.getAlertQueryFilter(alertConfiguration, context)

        const groupAxes = context.groupAxes.filter(groupAxis => {
            return alertConfiguration.groupAxes.map(gAxis => gAxis.toString()).includes(groupAxis.id)
        })

        const groupAxisSortObject = groupAxes.reduce(
            (acc, groupAxis) => Object.assign(acc, groupAxis.sortObjectForMongo),
            {}
        )

        return [
            {
                $match: query
            },
            {
                $sort: {
                    ...groupAxisSortObject,
                    alertCreationTime: -1
                }
            },
            {
                $group: {
                    _id: groupIdForMongoQuery(groupAxes),
                    firstElement: { $first: "$$ROOT" }
                }
            },
            {
                $replaceRoot: { newRoot: "$firstElement" }
            }
        ]
    },
    getAlertQueryFilter: function(alertConfiguration, context) {

        const habFunctionsByType = _(alertConfiguration.habFunctionHabilitation)
            .map(
                habFunction => _.find(context.userHabFunctions, {id: habFunction.toString()})
            )
            .compact()
            .groupBy(
                habFunction => _.lowerFirst(habFunction.organizationAxisJoin.joinedEntity)
            )
            .value();

        const storeAndOrganizationQuery = function() {
            if (!habFunctionsByType.centralAxis && (habFunctionsByType.storeAxis || habFunctionsByType.organizationAxis)) {
                const uStoreDbRefsInAlertConfig = _(habFunctionsByType.storeAxis || [])
                    .flatMap("habilitations")
                    .flatMap("organizationsJoin")
                    .map(oj => new global.ObjectID(oj.id))
                    .value();

                const uOrganizationDbRefsInAlertConfig = _(habFunctionsByType.organizationAxis || [])
                    .flatMap("habilitations")
                    .flatMap("organizationsJoin")
                    .map(oj => new global.ObjectID(oj.id))
                    .value();

                return {$or: _.compact([
                        uOrganizationDbRefsInAlertConfig.length && {organizations: {$in: uOrganizationDbRefsInAlertConfig}},
                        uStoreDbRefsInAlertConfig.length && {store: {$in: uStoreDbRefsInAlertConfig}}
                    ])};

            } else {
                return {};
            }
        }();

        let period;

        if (_.get(context, "data.period[0]") && _.get(context, "data.period[1]")) {
            period = context.data.period;
        } else {
            console.warn("Dates in context not found!");
            period = ["2022-06-30", "2022-06-30"];
        }

        const baseQuery = {
            alertConfiguration: new global.ObjectID(alertConfiguration._id),
            ...buildAlertPeriodQuery(period),
            group: new global.ObjectID(context.group.id)
        };

        if (context.data) {
            const {store, ticketCustomer, cashier, ticket} = context.data
            if (store?.id) {
                baseQuery.store = new global.ObjectID(store.id)
            }
            if (ticketCustomer) {
                baseQuery.ticketCustomer = ticketCustomer
            }
            if (cashier) {
                baseQuery.cashier = cashier
            }
            if (ticket) {
                baseQuery.ticket = ticket
            }
        }

        return _.defaults(baseQuery, storeAndOrganizationQuery);
    },
    groupAxesWithStore,
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) return callback(error)
            const moduleId = _.get(context, 'module.id')
            const accessId = _.get(context, 'access.id')
            const useSocket = _.get(context, 'module.useSocketsOnFind')
            if( ['m-S-alerts', 'm-S-viewByScope'].includes(moduleId) && accessId.endsWith('dt') && useSocket ) {
                const socketType = _.get(context, 'clientContext.accessId').endsWith('chart')
                    ? 'Chart'
                    : 'DT'
                global.app.S.AlertConfiguration.defaultFind(
                    context,
                    (e, alertConfigs) => {
                        if(e) {
                            global.ioSocket.emit(
                                `fetch${socketType}-failure-${context.user.id}${context.clientContext.accessId}`,
                                {error: e.message}
                            )
                        } else {
                            global.ioSocket.emit(
                                `fetch${socketType}-success-${context.user.id}${context.clientContext.accessId}`,
                                alertConfigs
                            )

                        }
                    })
                callback(null, [])
            } else {
                global.app.S.AlertConfiguration.defaultFind(context, (e, alertConfigs) => {
                    if(e) return callback(e);
                    callback(null, alertConfigs)
                })
            }
        })
    }
}

export const module_ = {
    object: "AlertConfiguration",
    tKey: "mTitle_admin_alert",
    deletionConfirmationMessage: 'alertConfigurationDeletionConfirmationMessage',
    name: "AlertConfiguration",
    category: {
        path: 'setting',
        icon: 'settings'
    },
    defaultSortBy : "name",
    defaultSortDirection : "ASC",
    viewMap: {
        dt: [
            {path: "name", translateName: true, width: 400},
            {path: "filterFieldsName", tKey: "dataPerimeter"},
            {path: "groupAxisName", tKey: "analysisMesh"},
            {path: "timeWindow", tKey: "dataPeriod", display: "tKey", translate: true, width: 100},
            {path: "dormant", tKey: "suspended", width: 50},
            //{path: "delay", tKey: "timeLagInDays", width: 120},
            {path: "habFunctionHabilitation", tKey: "profile(s)", translateName: true, initiallyNotVisible: true}
        ],
        form: {
            fields: [
                "code",
                {path: "name", type: "textarea", required: true},
                //"description",
                {
                    path: "alertDescriptions",
                    tKey: "descriptions",
                    removable: true,
                    viewMap: {
                        dt: [
                            {path: "language"}
                        ],
                        form: [
                            {path: "language"},
                            {path: "description", type: "richTextEditor"}
                        ]
                    }
                },
                {path: "filterFields", tKey: "dataPerimeter", display: "completeName", fieldPath: ["id", "completeName", "scopeAxe.code"], required: false},
                {path: "groupAxes", tKey: "analysisMesh", display: "tName", required: true, filters: ["alertAnalysisAxes"]},
                {
                    path: "preGroupAxes",
                    tKey: "intermediateAnalysisMesh",
                    display: "tName",
                    subscriptions: {
                        onChange: (newValue, oldValue, {module, store}) => {
                            const alertFieldsField = module.viewMap.form.fields.find(field => field.path === "alertFields")
                            const getListField = path => alertFieldsField.viewMap.dt.fields.find(field => field.path === path )
                            const getFormField = path => alertFieldsField.viewMap.form.fields.find(field => field.path === path )
                            const aggOperatorListField = getListField("aggOperator")
                            const aggOperatorFormField = getFormField("aggOperator")
                            const preAggOperatorListField = getListField("preAggOperator")
                            const preAggOperatorFormField = getFormField("preAggOperator")

                            const ruleHasPreGroupAxes = !!newValue?.length

                            store.dispatch(setFieldVisibility(preAggOperatorListField.id, ruleHasPreGroupAxes))
                            store.dispatch(setFieldVisibility(preAggOperatorFormField.id, ruleHasPreGroupAxes))
                            if(ruleHasPreGroupAxes) {
                                store.dispatch(setFieldVisibility(aggOperatorFormField.id, true))
                                store.dispatch(changeFieldDisabled(aggOperatorFormField.id, false))
                            }
                            store.dispatch(changeFieldProperty(
                                aggOperatorListField.id,
                                "tKey",
                                ruleHasPreGroupAxes ? "analysisMeshOperation": "operation"
                            ))
                            store.dispatch(changeFieldProperty(
                                aggOperatorFormField.id,
                                "tKey",
                                ruleHasPreGroupAxes ? "analysisMeshOperation": "operation"
                            ))

                            store.dispatch(changeFieldProperty(
                                "e_alertFields.e_alertEngineOrder",
                                "display",
                                !!newValue?.length ? "tKey2": "tKey"
                            ))
                            store.dispatch(changeFieldProperty(
                                "e_alertFields.l_alertEngineOrder",
                                "display",
                                !!newValue?.length ? "tKey2": "tKey"
                            ))
                        }
                    }
                },
                {
                    path: "conditionGroups",
                    removable: true,
                    viewMap: {
                        dt: [
                            {path: "name", translateName: true}
                        ],
                        form: [
                            {path: "name", type: "textarea"},
                            {
                                path: "conditions",
                                tKey: "filteringConditions",
                                removable: true,
                                viewMap: {
                                    dt: [
                                        {path: "source", tKey: "cashierFileId", translate: true},
                                        {path: "aggOperator", display: "tKey", tKey: "operation"},
                                        {path: "source2OrSource3", tKey: "cashierFileId2", translate: true},
                                        {path: "operator", display: "tKey", translate: true},
                                        //{path: "source2", tKey: "cashierFileId2"},
                                        //{path: "source3", tKey: "cashierFileId2"},
                                        {path: "condValue", tKey: "value"},
                                        {path: "condValues", tKey: "values"}
                                    ],
                                    form: [
                                        {
                                            path: "conditionType",
                                            type: "toggle",
                                            fieldPath: ["id", "name", "dataTypes"],
                                            sortList: false,
                                            subscriptions: {
                                                onChange: (newValue, oldValue, {module, store}) => {
                                                    const conditionGroupsField = module.viewMap.form.fields.find(field => field.path === 'conditionGroups')

                                                    const streamField = getFieldModuleForm("conditions", "stream", conditionGroupsField)
                                                    const operatorField = getFieldModuleForm("conditions", "operator", conditionGroupsField)
                                                    const valueField = getFieldModuleForm('conditions', 'condValue', conditionGroupsField)
                                                    const valuesField = getFieldModuleForm('conditions', 'condValues', conditionGroupsField)
                                                    const compareToField = getFieldModuleForm('conditions', 'source2', conditionGroupsField)
                                                    const aggOperator = getFieldModuleForm('conditions', 'aggOperator', conditionGroupsField)
                                                    const compareWithField = getFieldModuleForm('conditions', 'source3', conditionGroupsField)

                                                    const operator = operatorField.getValue()
                                                    const stream = streamField.getValue()
                                                    const showValuesField = !!operator && ['000000000000000000000018', '000000000000000000000019', '000000000000000000000020', '000000000000000000000021'].includes(operator.id)
                                                    const isApplySimpleConditionType = !!newValue && newValue.id === "applyCondition"
                                                    const isApplyComparisonType = !!newValue && newValue.id === "applyComparison"
                                                    const isApplyAttributeOperationConditionType = !!newValue && newValue.id === 'applyAttributeOperationCondition'

                                                    const isApplyConditionType = !!newValue && ['applyCondition', 'applyAttributeOperationCondition'].includes(newValue.id)

                                                    fetchDataLists(store, stream, newValue)

                                                    store.dispatch(
                                                        setFieldVisibility(
                                                            streamField.id,
                                                            !!newValue
                                                        )
                                                    )
                                                    store.dispatch(
                                                        setFieldVisibility(
                                                            valueField.id,
                                                            isApplyConditionType && !showValuesField
                                                        )
                                                    )
                                                    store.dispatch(
                                                        setFieldVisibility(
                                                            valuesField.id,
                                                            isApplyConditionType && showValuesField
                                                        )
                                                    )

                                                    if(isApplySimpleConditionType) {
                                                        store.dispatch(changeFieldProperty('e_conditionGroups.e_conditions.e_source', 'tKey', 'cashierFileId'))
                                                        compareToField.setValue(null)
                                                        aggOperator.setValue(null)
                                                        compareWithField.setValue(null)
                                                    }

                                                    if(isApplyComparisonType || isApplyAttributeOperationConditionType) {
                                                        store.dispatch(changeFieldProperty('e_conditionGroups.e_conditions.e_source', 'tKey', 'cashierFileId1'))
                                                    }

                                                    if(isApplyComparisonType) {
                                                        valueField.setValue(null)
                                                        valuesField.setValue(null)

                                                        if(showValuesField) {
                                                            operatorField.setValue(null)
                                                        }
                                                    }

                                                    const defaultFields = ["source", "operator"]


                                                    defaultFields.forEach(path => {
                                                        store.dispatch(setFieldVisibility(`e_conditionGroups.e_conditions.e_${path}`, !!newValue))
                                                    })
                                                    store.dispatch(setFieldVisibility(`e_conditionGroups.e_conditions.e_source2`, isApplyComparisonType))

                                                    store.dispatch(setFieldVisibility(`e_conditionGroups.e_conditions.e_aggOperator`, isApplyAttributeOperationConditionType))
                                                    store.dispatch(setFieldVisibility(`e_conditionGroups.e_conditions.e_source3`, isApplyAttributeOperationConditionType))


                                                    if(!!newValue) {
                                                        const state = store.getState()
                                                        const options = getDataListList(
                                                            state,
                                                            'm-S-alertConfiguration.AlertConfCondition_operator'
                                                        );
                                                        const filteredOptions = options.filter(option => {
                                                            if(newValue.id === "applyCondition") return true
                                                            return !["000000000000000000000018", "000000000000000000000019"].includes(option.id)
                                                        })

                                                        store.dispatch(setFieldListOptions("e_conditionGroups.e_conditions.e_operator", _.map(filteredOptions, "id")))
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            path: "stream",
                                            type: "toggle",
                                            subscriptions: {
                                                onChange: (newValue, oldValue, {module, store}) => {
                                                    const conditionGroupsField = module.viewMap.form.fields.find(field => field.path === 'conditionGroups')
                                                    const conditionTypeField = getFieldModuleForm("conditions", "conditionType", conditionGroupsField)

                                                    const conditionType = conditionTypeField.getValue()

                                                    fetchDataLists(store, newValue, conditionType)
                                                }
                                            },
                                            hidden: true
                                        },
                                        {path: "source", tKey: "cashierFileId", fieldPath: ['id', 'name', 'inputCorrespondenceByImportType.id'], filters: ["byFlowStructure", "byDataType", "isAlertModelFilterAxis"], hidden: true},
                                        {path: "aggOperator", display: "tKey", tKey: "operation", hidden: true},
                                        {
                                            path: "source3", tKey: "cashierFileId2", fieldPath: ['id', 'code', 'name', 'inputCorrespondenceByImportType.id'], filters: ["byFlowStructure", "byDataType", "isAlertModelFilterAxis"], hidden: true,
                                            subscriptions: {
                                                onChange: (newValue, oldValue, {module, store}) => {
                                                    const conditionGroupsField = module.viewMap.form.fields.find(field => field.path === 'conditionGroups')
                                                    const commonField = getFieldModuleForm("conditions", "source2OrSource3", conditionGroupsField)

                                                    commonField.setValue(newValue?.name)
                                                }
                                            }
                                        },
                                        {
                                            path: "operator",
                                            display: "tKey",
                                            translate: true,
                                            hidden: true,
                                            subscriptions: {
                                                onChange: (newValue, oldValue, {module, store}) => {
                                                    const conditionGroupsField = module.viewMap.form.fields.find(field => field.path === 'conditionGroups')
                                                    const conditionsField = conditionGroupsField.viewMap.form.fields.find(field => field.path === 'conditions')
                                                    const valueField = conditionsField.viewMap.form.fields.find(field => field.path === 'condValue')
                                                    const valuesField = conditionsField.viewMap.form.fields.find(field => field.path === 'condValues')
                                                    const conditionTypeField = conditionsField.viewMap.form.fields.find(field => field.path === 'conditionType')

                                                    const conditionType = conditionTypeField.getValue()
                                                    const isApplyConditionType = ['applyCondition', 'applyAttributeOperationCondition'].includes(conditionType?.id)

                                                    const showValuesField = newValue && ['000000000000000000000018', '000000000000000000000019', '000000000000000000000020', '000000000000000000000021'].includes(newValue.id)

                                                    store.dispatch(setFieldVisibility(valuesField.id, isApplyConditionType && showValuesField))
                                                    store.dispatch(setFieldVisibility(valueField.id, isApplyConditionType && !showValuesField))

                                                    if(!showValuesField) {
                                                        valuesField.setValue(null)
                                                    }

                                                    if(showValuesField) {
                                                        valueField.setValue(null)
                                                    }
                                                }
                                            }
                                        },
                                        {path: "condValue", tKey: "value", hidden: true},
                                        {path: "condValues", tKey: "values", type: 'creatableTags', hidden: true},
                                        {
                                            path: "source2", tKey: "cashierFileId2", fieldPath: ['id', 'code', 'name', 'inputCorrespondenceByImportType.id'], filters: ["byFlowStructure", "byDataType", "isAlertModelFilterAxis"], hidden: true,
                                            subscriptions: {
                                                onChange: (newValue, oldValue, {module, store}) => {
                                                    const conditionGroupsField = module.viewMap.form.fields.find(field => field.path === 'conditionGroups')
                                                    const commonField = getFieldModuleForm("conditions", "source2OrSource3", conditionGroupsField)

                                                    commonField.setValue(newValue?.name)
                                                }
                                            }
                                        },
                                        {path: "source2OrSource3", hidden: true},
                                    ]
                                }
                            },
                        ]
                    },
                },
                {
                    path: "timeWindow",
                    tKey: "dataPeriod",
                    display: "tKey",
                    translate: true,
                    clearable: false,
                    sortList: false,
                    default: {id: "00000000000000000000000a"},
                    subscriptions: {
                        onChange: (newValue, oldValue, {store}) => {

                            const tKeyByValueId = {
                                "00000000000000000000000a": "denominatorDelayByDay",
                                "00000000000000000000000b": "denominatorDelayByWeek",
                                "00000000000000000000000c": "denominatorDelayByMonth",
                                "00000000000000000000000d": "denominatorDelayByYear",
                                "00000000000000000000000e": "denominatorDelayByWeek",
                                "00000000000000000000000f": "denominatorDelayByMonth",
                                "000000000000000000000001": "denominatorDelayByYear",
                                "000000000000000000000002": "denominatorDelayByYear"
                            }
                            if (newValue) {
                                store.dispatch(changeFieldProperty("e_alertFields.e_denominatorDelay", "tKey", tKeyByValueId[newValue.id] ))
                            }
                        }
                    }
                },
                {
                    path: 'hasTimeInterval',
                    tKey: 'defineTimeInterval',
                    subscriptions: {
                        onChange: (newValue, oldValue, {store}) => {
                            store.dispatch(setFieldVisibility("e_startTime", !!newValue))
                            store.dispatch(setFieldVisibility("e_endTime", !!newValue))
                        }
                    }
                },
                {path: "startTime", tKey: "start", type: "timePicker"},
                {path: "endTime", tKey: "end", type: "timePicker"},
                // {path: "sendJournal", tKey: "includeInJournal"},
                {
                    path: "alertFields",
                    tKey: "rule_plural",
                    required: true,
                    removable: true,
                    viewMap: {
                        dt: [
                            {path: "alertEngineOrder", display: "tKey", fieldPath: ["id", "tKey", "tKey2"], translate: true, tKey: "computationOrder_short"},
                            {path: "themeJoin", tKey: "numerator", display: "completeName"},
                            {path: "themeFieldType", display: "tKey", translate: true, tKey: "amountOrNumber"},
                            {path: "denominatorTheme", tKey: "denominator", display: "completeName"},
                            {path: "denominatorThemeFieldType", display: "tKey", translate: true, tKey: "amountOrNumber"},
                            {path: "preAggOperator", display: "tKey", translate: true, tKey: "intermediateMeshOperation"},
                            {path: "aggOperator", display: "tKey", translate: true, tKey: "operation", hidden: true},
                            {path: "condOperator", display: "name", translate: true, tKey: "condition"},
                            {path: "value", tKey: "conditionValue"},
                        ],
                        form: [
                            {
                                path: "type",
                                type: 'toggle',
                                sortList: false,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const preGroupAxesField = module.viewMap.form.fields.find(field => field.path === "preGroupAxes")
                                        const alertFieldsField = module.viewMap.form.fields.find(field => field.path === "alertFields")
                                        const getField = path => alertFieldsField.viewMap.form.fields.find(field => field.path === path )
                                        const simpleRuleFields = ["alertEngineOrder", "themeJoin", "themeFieldType", "condOperator", "value"].map(path => getField(path))
                                        const ratioRuleFields = ["denominatorTheme", "denominatorThemeFieldType", "denominatorDelay"].map(path => getField(path))

                                        const groupAxes = preGroupAxesField.getValue()
                                        const hasGroupAxes = !!groupAxes?.length
                                        const displayedResultField = getField("displayedResult")
                                        const preAggOperatorField = getField("preAggOperator")
                                        const aggOperatorField = getField("aggOperator")

                                        const alertOrderField = getField("alertEngineOrder")
                                        const alertOrder = alertOrderField.getValue()

                                        const isRatioConditionAggregation = alertOrder?.id === "ratioConditionAggregation"
                                        if(alertOrder?.id === "aggregationRatioCondition" ){
                                            displayedResultField.setValue({id: 'indicators'})
                                        }

                                        if(alertOrder?.id === "ratioConditionAggregation") {
                                            aggOperatorField.setValue({id: '000000000000000000000001'})
                                        }
                                        store.dispatch(setFieldVisibility(displayedResultField.id, !!newValue?.id && isRatioConditionAggregation))
                                        store.dispatch(changeFieldDisabled(aggOperatorField.id, !!newValue?.id && isRatioConditionAggregation))
                                        store.dispatch(setFieldVisibility(aggOperatorField.id, !!newValue?.id && (!isRatioConditionAggregation || hasGroupAxes)))
                                        simpleRuleFields.forEach(field => store.dispatch(setFieldVisibility(field.id, newValue && ["simple", "ratio"].includes(newValue.id))))
                                        ratioRuleFields.forEach(field => store.dispatch(setFieldVisibility(field.id, newValue?.id === "ratio")))
                                        store.dispatch(setFieldVisibility(preAggOperatorField.id, hasGroupAxes && newValue && ["simple", "ratio"].includes(newValue.id)))
                                        if(newValue?.id === 'simple') {
                                            ratioRuleFields.forEach(field => {
                                                if(field.path === 'denominatorDelay') {
                                                    field.setValue(0)
                                                    return
                                                }
                                                field.setValue(null)
                                            })
                                        }
                                        store.dispatch(changeFieldProperty("e_alertFields.e_themeJoin", "tKey", newValue?.id === "simple" ? "indicator" : "numerator"))

                                    }
                                }
                            },
                            {path: "alertEngineOrder", display: "tKey", fieldPath: ["id", "tKey", "tKey2"], translate: true, tKey: "computationOrder", hideLabel: false, default: {id: "ratioConditionAggregation"}, hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const alertFieldsField = module.viewMap.form.fields.find(field => field.path === "alertFields")
                                        const typeField = alertFieldsField.viewMap.form.fields.find(field => field.path === "type")
                                        const type = typeField.getValue()
                                        const displayedResultField = alertFieldsField.viewMap.form.fields.find(field => field.path === "displayedResult")
                                        const aggOperatorField = alertFieldsField.viewMap.form.fields.find(field => field.path === "aggOperator")
                                        const preGroupAxesField = module.viewMap.form.fields.find(field => field.path === "preGroupAxes")

                                        const groupAxes = preGroupAxesField.getValue()
                                        const hasGroupAxes = !!groupAxes?.length

                                        const isRatioConditionAggregation = newValue?.id === "ratioConditionAggregation"
                                        if(newValue?.id === "aggregationRatioCondition") {
                                            displayedResultField.setValue({id: "indicators"})
                                        }
                                        if(newValue?.id === "ratioConditionAggregation") {
                                            aggOperatorField.setValue({id: "000000000000000000000001"})
                                        }
                                        store.dispatch(setFieldVisibility(displayedResultField.id,!!type?.id && newValue?.id === 'ratioConditionAggregation'))
                                        store.dispatch(changeFieldDisabled(aggOperatorField.id,!!type?.id && newValue?.id === 'ratioConditionAggregation' && !hasGroupAxes))
                                        store.dispatch(setFieldVisibility(aggOperatorField.id, !!type?.id && (!isRatioConditionAggregation || hasGroupAxes)))
                                    }
                                }
                            },
                            {path: "themeJoin", tKey: "numerator", display: "completeName", hidden: true},
                            {path: "themeFieldType", display: "tKey", translate: true, tKey: "amountOrNumber", type: 'toggle', default: {id: "000000000000000000000101"}, hidden: true},
                            {path: "denominatorTheme", tKey: "denominator", display: "completeName", required: true, hidden: true},
                            {path: "denominatorThemeFieldType", display: "tKey", translate: true, tKey: "amountOrNumber", type: 'toggle', default: {id: "000000000000000000000101"}, hidden: true},
                            {path: "denominatorDelay", tKey: "denominatorPeriodDelay", wholePositiveNumber: true, default: 0, hidden: true},

                            {path: "preAggOperator", display: "tKey", translate: true, tKey: "intermediateMeshOperation", default: {id: "000000000000000000000001"}, hidden: true},
                            {path: "aggOperator", display: "tKey", translate: true, tKey: "operation", default: {id: "000000000000000000000001"}, hidden: true},
                            {path: "condOperator", display: "name", translate: true, tKey: "condition", filters: ["basicOperations"], required: true, hidden: true},
                            {path: "value", required: true, default: 0, hidden: true},
                            {path: "displayedResult", tKey: "retainedResult", hidden: true}
                        ]
                    }
                },
                {path: "habFunctionHabilitation", translateName: true, tKey: "habilitation", required: false},
                {path: "reason", hidden: true},
                {path: 'hasCalculatedData', hidden: true},
                {path: "dormant", tKey: "suspend"}
            ],
            onOpen: ({ store }) => {
                const state = store.getState()
                //const objectMode = state.ui.objectMode
                const hasCalculatedData = state.edit.object.data.hasCalculatedData

                const fields = [
                    'e_code', 'e_filterFields', 'e_groupAxes',
                    'e_timeWindow', 'e_preGroupAxes', 'e_alertFields'
                ]
                fields.forEach(field => store.dispatch(changeFieldDisabled(field, hasCalculatedData)))
            }
        }
    },
    filters: ["isDormant"]
}


export const alertModule = {
    object: "AlertConfiguration",
    tKey: "mTitle_alertConfiguration",
    name: "Alerts",
    category: {
        path: "tracking",
        icon: 'briefcase'
    },
    defaultSortBy: "tName",
    defaultSortDirection: "ASC",
    charts: [
        {
            title: "alertDistributionRate",
            type: "donutChart",
            axis: "tName",
            dataKeys: [
                {key: "alertNb", label: "alertsNumber"}
            ]
        },
        {
            type: "barChart",
            axis: "tName",
            dataKeys: [
                {key: "alertNb", label: "alertsNumber"},
                {key: "consultedAlertsNb", label: "consultedAlertsNumber"}
            ]
        },
        {
            title: "alertsNumberEvolution",
            type: "stackedAreaChart",
            axis: "dataPeriod",
            format: {
                kind: "mergeSeriesByX",           // new formatter id
                seriesIdKey: "tName",       // where series id lives
                seriesDataKey: "alertsNbByDate",    // array of points
                xKey: "dataPeriod",                     // x axis in points
                yKey: "alertsNb",                  // value in points
            },
            aggregate: {
                mode: "auto",
                op: "sum",
                thresholds: { dayMaxDays: 30, weekMaxDays: 90 },
                outFormat: "fr"
            }
        }
    ],
    newable: false,
    updatable: false,
    removable: false,
    useSocketsOnFind: true,
    viewMap: {
        dt: [
            {path: "tName", tKey: "alertType", width: 300 },
            {path: "timeWindow", tKey: "periodicity", display: "tKey", width: 100},
            {path: "groupAxes", tKey: "analyzedObject", display: "tName", width: 100},
            {path: "alertNb", tKey: "number", width: 25},
            {path: "consultedAlertsNb", tKey: "analyzedAlertsNb", width: 25},
            {path: "themeNames", tKey: "indicator_plural", type: "creatableTags"},
            {path: "summedAlertsValues", tKey: "totalValue", type: "number", dynamic: true, tooltip: true, disableColumnsSort: true, width: 80},
            {path: "alertsNbByDate", hidden: true}
        ],
        form: [
            {path: "tName", tKey: "alertType", writable: false},
            {path: "groupAxisName", tKey: "analyzedObject"},
            {path: "themesNameWithDelay", tKey: "indicator_plural", type: "creatableTags"},
            {path: "alertNb", tKey: "numberOfAlerts", disabled: true},
            {path: "brutSummedAlertsValues", tKey: "totalIndicatorsValue"},
            {
                path: "alertsInDatesForUser",
                tKey: "alert_plural",
                type: "dtObjects",
                applyBoard: true,
                maxRows: 20,
                // options: {searchBar: true},
                fields: [
                    {path: 'consulted', type: 'checkbox', tKey: 'Vu', width: 20, disableSort: true, enableSelectAll: true},
                    {path: "lastUpdate", tKey: "lastUpdate_short", type: "dateString", dateFormat: "YYYY-MM-DD HH:mm", initiallyNotVisible: true},
                    {path: "lastUpdateBy", tKey: "user", type: "object", display: "name", initiallyNotVisible: true},
                    {path: "dataPeriod", tKey: "period", width: 90},
                    {path: "meshWithoutGroupAxisLinks", tKey: "elements", type: "links", width: 380},
                    {path: "uniqValuesByDelay", tKey: "values", width: 40, dynamic: true, type: "customized", tooltip: true},
                ],
                subscriptions: {
                    onChange: (newValue, previousValue, {store}) => {
                        const validateButton = {
                            action: 'updateAlertStatus',
                            pristine: true,
                            bsStyle: 'primary',
                            tKey: 'updateAlertStatus',
                            type: 'action'
                        }

                        const returnButton = {
                            type: 'return',
                            tKey: 'return',
                            bsStyle: 'default'
                        }
                        store.dispatch(setFormButtons([validateButton, returnButton]))
                    }
                }
                // mField: {
                //     reloadList: true,
                // }
            },
            {path: "consultedAlertsNb", hidden: true},
        ],
        chart: ["tName", "alertNb"]
    },
    filters: [
        {
            type: "dateRange",
            default: [lastWeekISO, todayISO],
            path: "period",
            client: true,
            async: true,
            query: async (context, callback) => {
                const period = _.get(context, "data.period") || []
                if (!period[0] || !period[1]) return callback(null, {})

                try {
                    const newContext = await cacheOnContext(context)

                    const alertConfigIdsWithAlerts = _(newContext.data.alertsByConfigs)
                        .map(alertsByConfig => (
                            {
                                _id: alertsByConfig.alertConfiguration._id,
                                count: alertsByConfig.alerts.length
                            }
                        ))
                        .filter(idAndCount => idAndCount.count > 0)
                        .map("_id")
                        .value();

                    callback(null, {
                        _id: {$in: alertConfigIdsWithAlerts}
                    });
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "alertConfigurations",
            object: "AlertConfiguration",
            type: "tags",
            display: "tName",
            client: true,
            default: [],
            filters: ["alertConfigurationsByHabFunctions"],
            clearable: true,
            timer: 3,
            width: 6
        },
    ]
}

export const ViewByScopeModule = {
    object: "AlertConfiguration",
    tKey: "mTitle_viewByScope",
    name: "ViewByScope",
    category: {
        path: "tracking",
        icon: 'briefcase'
    },
    defaultSortBy: "tName",
    defaultSortDirection: "ASC",
    chart: {
        type: "donutChart",
        keys: ["tName"],
        data: 'alertNb'
    },
    newable: false,
    updatable: false,
    removable: false,
    useSocketsOnFind: true,
    manualFilters: true,
    viewMap: {
        dt: [
            {path: "tName", tKey: "alertType", width: 300 },
            {path: "timeWindow", tKey: "periodicity", display: "tKey", width: 100},
            {path: "groupAxes", tKey: "analyzedObject", display: "tName", width: 100},
            {path: "alertNb", tKey: "number", width: 25},
            {path: "consultedAlertsNb", tKey: "analyzedAlertsNb", width: 25},
            {path: "themeNames", tKey: "indicator_plural", type: "creatableTags"},
            {path: "summedAlertsValues", tKey: "totalValue", type: "number", dynamic: true, tooltip: true, disableColumnsSort: true, width: 80}
        ],
        form: [
            {path: "tName", tKey: "alertType", writable: false},
            {path: "groupAxisName", tKey: "analyzedObject"},
            {path: "themesNameWithDelay", tKey: "indicator_plural", type: "creatableTags"},
            {path: "alertNb", tKey: "numberOfAlerts", disabled: true},
            {path: "brutSummedAlertsValues", tKey: "totalIndicatorsValue"},
            {
                path: "alertsInDatesForUser",
                tKey: "alert_plural",
                type: "dtObjects",
                applyBoard: true,
                graphViewEnabled: true,
                graphXAxisKey: 'dataPeriod',
                graphYAxisKey: 'uniqValuesByDelay',
                maxRows: 20,
                // options: {searchBar: true},
                fields: [
                    {path: 'consulted', type: 'checkbox', tKey: 'Vu', width: 20, disableSort: true, enableSelectAll: true},
                    {path: "lastUpdate", tKey: "lastUpdate_short", type: "dateString", dateFormat: "YYYY-MM-DD HH:mm", initiallyNotVisible: true},
                    {path: "lastUpdateBy", tKey: "user", type: "object", display: "name", initiallyNotVisible: true},
                    {path: "dataPeriod", tKey: "period", width: 90},
                    {path: "meshWithoutGroupAxisLinks", tKey: "elements", type: "links", width: 380},
                    {path: "uniqValuesByDelay", tKey: "values", width: 40, dynamic: true, type: "customized", tooltip: true},
                ],
                subscriptions: {
                    onChange: (newValue, previousValue, {store}) => {
                        const validateButton = {
                            action: 'updateAlertStatus',
                            pristine: true,
                            bsStyle: 'primary',
                            tKey: 'updateAlertStatus',
                            type: 'action'
                        }

                        const returnButton = {
                            type: 'return',
                            tKey: 'return',
                            bsStyle: 'default'
                        }
                        store.dispatch(setFormButtons([validateButton, returnButton]))
                    }
                }
                // mField: {
                //     reloadList: true,
                // }
            },
            {path: "consultedAlertsNb", hidden: true},
        ],
        chart: ["tName", "alertNb"]
    },
    filters: [
        {
            type: "dateRange",
            default: [lastWeekISO, todayISO],
            path: "period",
            client: true,
            async: true,
            query: async (context, callback) => {
                const period = _.get(context, "data.period") || []
                if (!period[0] || !period[1]) return callback(null, {})

                try {
                    const newContext = await cacheOnContext(context)

                    const alertConfigIdsWithAlerts = _(newContext.data.alertsByConfigs)
                        .map(alertsByConfig => (
                            {
                                _id: alertsByConfig.alertConfiguration._id,
                                count: alertsByConfig.alerts.length
                            }
                        ))
                        .filter(idAndCount => idAndCount.count > 0)
                        .map("_id")
                        .value();

                    callback(null, {
                        _id: {$in: alertConfigIdsWithAlerts}
                    });
                } catch (e) {
                    return callback(e)
                }
            }
        },
        {
            path: "alertConfigurations",
            object: "AlertConfiguration",
            type: "tags",
            display: "tName",
            client: true,
            default: [],
            filters: ["alertConfigurationsByHabFunctions"],
            clearable: true,
            width: 6
        },
        {
            path: "store",
            tKey: "store",
            object: "Store",
            display: "name",
            default: {id: null},
            client: true
        },
        {
            path: "ticketCustomer",
            tKey: "customer",
            type: "text",
            client: true
        },
        {
            path: "cashier",
            tKey: "cashier",
            type: "text",
            client: true
        },
        {
            path: "ticket",
            tKey: "ticket",
            type: "text",
            client: true
        }
    ]
}
